interface IOptions {
    wrapper: HTMLElement;
}

class ScrollSlider {
    private wrapper: HTMLElement | null;
    private inner: HTMLElement | null;
    private sliderButton: HTMLElement | null;
    private overlay: HTMLElement | null;
    private startingX: number;
    private overlayStartingX: number;
    private overlayStartingY: number;

    constructor() {
        this.wrapper = null;
        this.sliderButton = null;
        this.overlay = null;
        this.startingX = 0;
        this.overlayStartingX = 0;
        this.overlayStartingY = 0;
    }

    /**
     * Инициализация модуля
     * @param {object} options - параметры
     */
    init(options: IOptions): void {
        this.wrapper = options.wrapper;
        this._getElements();
        this._bindEvents();
    }

    /**
     * Получаем элементы со страницы
     * @private
     */
    private _getElements(): void {
        this.inner = this.wrapper?.querySelector('.j-scroll-slider-inner') || null;
        this.sliderButton = this.wrapper?.querySelector('.j-scroll-slider') || null;
        this.overlay = this.wrapper?.querySelector('.j-scroll-slider-overlay') || null;
    }

    private _bindEvents(): void {
        this.sliderButton?.addEventListener('touchstart', this._moveInnerStart.bind(this));
        this.sliderButton?.addEventListener('touchmove', this._moveInnerMove.bind(this));
        this.inner?.addEventListener('scroll', this._moveSlider.bind(this));
        this.overlay?.addEventListener('touchstart', this._overlayMoveStart.bind(this));
        this.overlay?.addEventListener('touchmove', this._overlayMove.bind(this));
        this.overlay?.addEventListener('click', () => {
            if (this.overlay) {
                this.overlay.style.display = 'none';
            }
        });
    }

    private _overlayMoveStart(event: TouchEvent): void {
        this.overlayStartingX = event.touches[0]?.clientX || 0;
        this.overlayStartingY = event.touches[0]?.clientY || 0;
    }

    private _overlayMove(event: TouchEvent): void {
        const currentX = event.touches[0]?.clientX;
        const currentY = event.touches[0]?.clientY;
        const scrollX = currentX ? currentX - this.overlayStartingX : 0;
        const scrollY = currentY ? currentY - this.overlayStartingY : 0;

        if (Math.abs(scrollX) > Math.abs(scrollY) && this.overlay) {
            this.overlay.style.display = 'none';
        }
    }

    private _moveInnerStart(event: TouchEvent): void {
        if (this.startingX === 0 && event.touches[0]) {
            this.startingX = event.touches[0].clientX;
        }

        if (this.overlay) {
            this.overlay.style.display = 'none';
        }
    }

    private _moveInnerMove(event: TouchEvent): void {
        let total = 0;

        const currentX = event.touches[0]?.clientX || 0;
        const scroll = currentX - this.startingX;

        if (this.inner) {
            total = this.inner.scrollWidth - this.inner.clientWidth;
        }

        if (scroll >= 0 && scroll <= total) {
            this.inner?.scrollTo(scroll * 5, 0);
        }
    }

    private _moveSlider(): void {
        if (!this.inner) {
            return;
        }

        const scroll = this.inner.scrollLeft;
        const total = this.inner.scrollWidth - this.inner.clientWidth;

        if (this.sliderButton) {
            this.sliderButton.style.left = `${(scroll / total) * 100}%`;
            this.sliderButton.style.transform = `translateX(-${(scroll / total) * 100}%)`;
        }
    }
}

export default ScrollSlider;
